import { render } from "./CreateAppointment.vue?vue&type=template&id=ebd6aad8&scoped=true"
import script from "./CreateAppointment.vue?vue&type=script&lang=js"
export * from "./CreateAppointment.vue?vue&type=script&lang=js"

import "./CreateAppointment.vue?vue&type=style&index=0&id=ebd6aad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd6aad8"]])

export default __exports__